import { motion } from 'framer-motion';
// import Communication from '@/features/contact/components/svg/Communication';
// import { useTranslation } from 'react-i18next';
import MainHero from '@/components/MainHero';

export default function MainSection({
    title,
    description,
    icon,
    className,
}: {
    title?: string;
    description?: string;
    icon?: React.ReactNode; 
    className?: string;
}) {
    return (
        <MainHero className={className}>
            <div className="bg-mainsection rounded-t-[40px]">
                <div className="flex flex-col-reverse items-center gap-4 sm:flex-row-reverse lg:gap-14 py-5 px-5">
                    <div className="flex-1 text-center sm:text-start text-white-blue-50 mb-5 sm:mb-0">
                        <motion.h1
                            className="font-alexandria text-mainsection-text font-semibold sm:text-[26px] text-[24px] md:text-[32px] lg:text-[36px] leading-[125%]"
                            initial={{ y: -20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.25, duration: 0.5 }}
                        >
                            {title}
                        </motion.h1>

                        <motion.p
                            className="mt-4 sm:mt-5 font-medium text-[13px] sm:text-base lg:text-lg leading-7 lg:leading-8 md:max-w-3xl max-w-[400px] lg:px-0 sm:px-3 px-2 text-mainsection-description"
                            initial={{ y: -16, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.45, duration: 0.5 }}
                        >
                            {description}
                        </motion.p>
                    </div>

                    <motion.div
                        className="flex-shrink-0"
                        initial={{ opacity: 0, scale: 0.92 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.35, duration: 0.5 }}
                    >
                        {icon}
                    </motion.div>
                </div>
            </div>
        </MainHero>
    );
}
